/**
 * Build the wp-web webview media-report URL used by the new report flow:
 *   /webview/report/media/:mediaUrl?mediaType=&mediaLocationType=&mediaLocationId=
 *
 * Every value is encoded — `mediaUrl` is the route's path param and the query
 * values (especially `mediaLocationId`, which originates from a DOM data
 * attribute) can carry characters that would otherwise corrupt the path or the
 * query string. Keeping the route contract in one place means the encoding —
 * and any future change to how `mediaUrl` is passed (path vs. query) — lives in
 * one place too.
 *
 * @param {Object} params
 * @param {string} params.mediaUrl - URL of the media being reported (path param).
 * @param {string} params.mediaType - api-v4 media type enum, e.g.
 *   story_header_image | story_header_video | story_cover_image |
 *   story_inline_image | story_inline_video.
 * @param {string} params.mediaLocationType - e.g. "storyPart".
 * @param {(string|number)} params.mediaLocationId - story-part id.
 * @returns {string} the relative webview report URL.
 */
export const buildMediaReportUrl = ({
  mediaUrl,
  mediaType,
  mediaLocationType,
  mediaLocationId
}) => {
  const query = [
    "mediaType=" + encodeURIComponent(mediaType),
    "mediaLocationType=" + encodeURIComponent(mediaLocationType),
    "mediaLocationId=" + encodeURIComponent(mediaLocationId)
  ].join("&");

  return `/webview/report/media/${encodeURIComponent(mediaUrl)}?${query}`;
};
